import { countryRepositoryImplementation } from '@shared/infrastructure/http/repositories/country/countryRepositoryImplementation';
import { Country } from './country.aggregate';

export interface CountryRepository {
  getCountries: () => Promise<Country[]>;
}

export const countryRepository: CountryRepository = {
  getCountries: () => {
    return countryRepositoryImplementation.getCountries();
  }
};
